import "./styles.scss";

import { memo, useEffect, useState } from "react";

import calcContextMenuTopPosition from "./helpers/calcContextMenuTopPosition";
import { createPortal } from "react-dom";
import { useContent } from "contexts/contentContext/contentContext";
import useMediaQueries from "hooks/useMediaQueries";

interface LabelContextMenuPropsI {
  menuItemIndex: number;
  onLabelEdit: () => void;
  onLabelDelete: () => void;
  offsetY?: number;
  renderRoot: HTMLElement | null;
}

const LabelContextMenu = memo((props: LabelContextMenuPropsI) => {
  const { menuItemIndex, offsetY, onLabelEdit, onLabelDelete, renderRoot } =
    props;
  const [menuTopPosition, setMenuTopPosition] = useState(0);
  const { desktopCondition } = useMediaQueries();

  // BLACK FRIDAY PROMO
  const { getBlackFridayTimeCookie, getTextByKey } = useContent();
  // BLACK FRIDAY PROMO
  
  useEffect(() => {
    const calculatedContextMenuTopPosition = calcContextMenuTopPosition(
      menuItemIndex,
      offsetY,
      desktopCondition,
      getBlackFridayTimeCookie()
    );

    setMenuTopPosition(calculatedContextMenuTopPosition);
  }, [
    // ------------- recalculate if BLACK FRIDAY PROMO appeared
    getBlackFridayTimeCookie,
    // -------------
    menuItemIndex,
    offsetY,
    desktopCondition,
  ]);

  return renderRoot ? (
    createPortal(
      <div
        className="label-context-menu-wrapper"
        style={{
          top: menuTopPosition,
        }}
      >
        <ul>
          <li onClick={onLabelEdit}>{getTextByKey("edit-label")}</li>
          <li onClick={onLabelDelete}>{getTextByKey("delete-label")}</li>
        </ul>
      </div>,
      renderRoot
    )
  ) : (
    <></>
  );
});

export default LabelContextMenu;
